import { h } from "@stencil/core";
/**
 * The `ch-tabular-grid-settings-columns` component represents the settings for a grid's columns.
 */
export class ChTabularGridSettingsColumns {
    constructor() {
        this.columns = undefined;
    }
    handleClick = (eventInfo) => {
        const checkbox = eventInfo.target;
        const column = this.columns.find(column => column.columnId === checkbox.name);
        column.hidden = !checkbox.checked;
        eventInfo.stopPropagation();
    };
    getColumnsSorted() {
        return [...this.columns].sort((a, b) => {
            if (a.order < b.order) {
                return -1;
            }
            if (a.order > b.order) {
                return 1;
            }
            return 0;
        });
    }
    render() {
        const columnsSorted = this.getColumnsSorted();
        return (h("ul", { key: 'ad73f0ef6cc1623455ea2422ccf8ea57a9589bbe' }, columnsSorted.map(column => (h("li", { part: "column" }, h("label", { part: "column-label" }, h("input", { part: !column.hidden
                ? "column-visible column-visible-checked"
                : "column-visible", type: "checkbox", checked: !column.hidden, disabled: !column.hideable, name: column.columnId, onClick: this.handleClick }), column.columnName))))));
    }
    static get is() { return "ch-tabular-grid-settings-columns"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["tabular-grid-settings-columns.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tabular-grid-settings-columns.css"]
        };
    }
    static get properties() {
        return {
            "columns": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "HTMLChTabularGridColumnElement[]",
                    "resolved": "HTMLChTabularGridColumnElement[]",
                    "references": {
                        "HTMLChTabularGridColumnElement": {
                            "location": "global",
                            "id": "global::HTMLChTabularGridColumnElement"
                        }
                    }
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "An array of column elements to render."
                }
            }
        };
    }
}
